export default __webpack_public_path__ + "static/media/kandidat.7cc0d5a4.svg";